import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'gt-custom-select',
  standalone: true,
  template: `
    <ion-header mode="ios">
      <ion-toolbar mode="ios">
        <ion-title>{{ 'ONBOARDING.REGISTER.' + titleKey | transloco }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="close()">{{ 'COMMON.CANCEL' | transloco }}</ion-button>
        </ion-buttons>
      </ion-toolbar>
      <ion-toolbar>
        <ion-searchbar mode="ios" [(ngModel)]="searchTerm"></ion-searchbar>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item class="ion-border" *ngFor="let item of filter()" (click)="selectItem(item)" tappable>
          <img
            *ngIf="item.image"
            [src]="item.image"
            [alt]="item.label"
            style="width: 24px; display: inline-block; margin-right: 12px"
          />
          <ion-label> {{ item.flag ?? '' }} {{ item.label }} {{ item.dial ?? '' }}</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  `,
  imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, TranslocoModule],
})
export class CustomSelectComponent {
  public searchTerm = '';
  @Input() items: { value: string; label: string; flag?: string; dial?: string; image?: string }[] = [];
  @Input() titleKey = 'NATIONALITY';

  constructor(private modalController: ModalController) {}

  filter() {
    if (!this.searchTerm) return this.items;

    const term = this.searchTerm.toLowerCase().trim();

    return this.items.filter((item) => {
      const label = item.label?.toLowerCase() ?? '';
      const dial = item.dial?.toLowerCase() ?? '';
      return label.includes(term) || dial.includes(term);
    });
  }

  selectItem(item: any) {
    this.modalController.dismiss({
      selectedItem: item.dial ? item.dial : item.value,
    });
  }

  close() {
    this.modalController.dismiss();
  }
}
